import moment from 'moment';
import {
  CreditasResponsible,
  InsurerResponsibleRequest
} from '../types/CreditasResponsible';
import { EstateInsurerDataForGetEstatesResponseDTO } from '../dtos/estate/estate-for-get-estates-response.dto';
import { isCpf, maskCpf } from '../shared/documents/cpf';
import { maskPhoneNumber } from '../services/masks';
import { isValidEmail } from './emailValidator';

export const emptyCreditasResponsible = (): CreditasResponsible => ({
  responsibleName: '',
  responsibleCpf: '',
  responsibleMotherName: '',
  responsibleBirthDate: '',
  responsibleEmail: '',
  responsiblePhone: ''
});

export const creditasResponsibleFromResponse = (
  data: EstateInsurerDataForGetEstatesResponseDTO
): CreditasResponsible => ({
  tableId: data.id,
  responsibleName: data.responsible_name || '',
  responsibleCpf: maskCpf(data.responsible_cpf || ''),
  responsibleMotherName: data.responsible_mother_name || '',
  responsibleBirthDate: data.responsible_birth_date
    ? moment(data.responsible_birth_date, 'YYYY-MM-DD', true).format('DD/MM/YYYY')
    : '',
  responsibleEmail: data.responsible_email || '',
  responsiblePhone: maskPhoneNumber(data.responsible_phone || '')
});

export const creditasResponsibleToRequest = (
  data: CreditasResponsible
): InsurerResponsibleRequest => ({
  responsibleName: data.responsibleName.trim() || null,
  responsibleCpf: data.responsibleCpf.replace(/\D/g, '') || null,
  responsibleMotherName: data.responsibleMotherName.trim() || null,
  responsibleBirthDate: data.responsibleBirthDate
    ? moment(data.responsibleBirthDate, 'DD/MM/YYYY', true).format('YYYY-MM-DD')
    : null,
  responsibleEmail: data.responsibleEmail.trim() || null,
  responsiblePhone: data.responsiblePhone.replace(/\D/g, '') || null
});

export type CreditasResponsibleErrors = Partial<
  Record<keyof CreditasResponsible, string>
>;

export const validateCreditasResponsible = (
  data: CreditasResponsible
): CreditasResponsibleErrors => {
  const errors: CreditasResponsibleErrors = {};
  const requiredFields: { key: keyof CreditasResponsible; message: string }[] = [
    { key: 'responsibleName', message: 'Informe o nome do responsável.' },
    { key: 'responsibleCpf', message: 'Informe o CPF.' },
    { key: 'responsibleMotherName', message: 'Informe o nome da mãe.' },
    { key: 'responsibleBirthDate', message: 'Informe a data de nascimento.' },
    { key: 'responsibleEmail', message: 'Informe o e-mail.' },
    { key: 'responsiblePhone', message: 'Informe o telefone.' }
  ];
  requiredFields.forEach(({ key, message }) => {
    if (!data[key]?.trim()) errors[key] = message;
  });
  if (data.responsibleCpf && !isCpf(data.responsibleCpf)) {
    errors.responsibleCpf = 'Informe um CPF válido.';
  }
  if (data.responsibleEmail && !isValidEmail(data.responsibleEmail.trim())) {
    errors.responsibleEmail = 'Informe um e-mail válido.';
  }
  if (
    data.responsiblePhone &&
    !/^\d{10,11}$/.test(data.responsiblePhone.replace(/\D/g, ''))
  ) {
    errors.responsiblePhone = 'Informe um telefone com DDD.';
  }
  if (data.responsibleBirthDate) {
    const date = moment(data.responsibleBirthDate, 'DD/MM/YYYY', true);
    if (!date.isValid() || date.isAfter(moment(), 'day')) {
      errors.responsibleBirthDate = 'Informe uma data de nascimento válida.';
    }
  }
  return errors;
};
